import { AppContainerProps, AppNavItem } from './utils/interfaces';
import styles from './app-switcher.module.scss';
import { AppSwitcherTitle } from './components/app-switcher-title/app-switcher-title';
import { useToggleDropdown } from './utils/useToggleDropdown';
import { AppItemWithoutDropdown } from './components/apps/app-item-without-dropdown';

export function AppSwitcher<App extends AppNavItem>({
  applications,
}: AppContainerProps<App>) {
  const { showDropdown, toggleDropdown } = useToggleDropdown(false);
  return (
    <div
      className={styles['app-switcher-button']}
      onClick={applications.length > 0 ? toggleDropdown : undefined}
    >
      <AppSwitcherTitle active={showDropdown} />
      <div
        className={`${styles['app-switcher-dropdown-container']} ${
          showDropdown ? styles['active'] : ''
        }`}
      >
        {applications.length > 0 && (
          <div
            className={styles['application-header']}
            style={{ marginTop: '8px' }}
          >
            Applications
          </div>
        )}
        <div className={styles['application-container']}>
          <div className={styles['app-container']}>
            {applications.map((app) => (
              <AppItemWithoutDropdown key={app.pageName} {...app} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
